module.exports = __webpack_public_path__ + "img/neutral.2381d3ef.png";